import React from 'react';
import { useGameLoop } from './hooks/useGameLoop';
import { useStore } from './store/useStore';
import { Coins } from 'lucide-react';
import { Layout } from './components/Layout';

// Feature Components
import { MiningPanel } from './components/features/MiningPanel';
import { FarmingPanel } from './components/features/FarmingPanel';
import { MarketPanel } from './components/features/MarketPanel';
import { SettingsPanel } from './components/features/SettingsPanel';
import { CraftingPanel } from './components/features/CraftingPanel';
import { CompendiumPanel } from './components/features/CompendiumPanel';
import TechTree from './features/TechTree/TechTree';
import { DebugConsole } from './components/common/DebugConsole';
import { LevelingNotification } from './components/common/LevelingNotification';

import { checkAndFinalizeHardReset } from './store/saveSystem';

export const App = () => {
  // Check for force reset flag on mount
  React.useEffect(() => {
    if (checkAndFinalizeHardReset()) {
      return; // Stop execution if resetting
    }
  }, []);

  useGameLoop();
  const [currentView, setCurrentView] = React.useState<'mining' | 'farming' | 'market' | 'settings' | 'tech_tree' | 'crafting' | 'compendium'>('market');
  const resources = useStore((state) => state.resources);

  const headerContent = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <div className="resource-item" style={{ color: 'var(--color-text-primary)' }}>
        <Coins size={16} style={{ color: 'var(--color-accent)' }} />
        <span> {resources.gold.toFixed(0)}</span>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (currentView) {
      case 'mining':
        return <MiningPanel />;
      case 'farming':
        return <FarmingPanel />;
      case 'settings':
        return <SettingsPanel />;
      case 'crafting':
        return <CraftingPanel />;
      case 'tech_tree':
        return <TechTree />;
      case 'compendium':
        return <CompendiumPanel />;
      case 'market':
      default:
        return <MarketPanel />;
    }
  };

  return (
    <>
      <Layout
        headerContent={headerContent}
        currentView={currentView}
        onNavigate={(view) => setCurrentView(view as any)}
      >
        {renderContent()}
      </Layout>
      <LevelingNotification />
      <DebugConsole />
    </>
  );
};
